import { useCallback, useEffect } from 'react';

/** A pristine form closes silently; a changed one confirms first. Cancel, the
 *  close button, the scrim and Escape all go through the returned function. */
export function useDirtyClose(dirty: boolean, onClose: () => void, discardPrompt: string) {
  const requestClose = useCallback(() => {
    if (dirty && !window.confirm(discardPrompt)) return;
    onClose();
  }, [dirty, onClose, discardPrompt]);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') requestClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [requestClose]);
  return requestClose;
}
